import { render, staticRenderFns } from "./RouteForwarder.vue?vue&type=template&id=1d6c2f01&"
import script from "./RouteForwarder.vue?vue&type=script&lang=js&"
export * from "./RouteForwarder.vue?vue&type=script&lang=js&"
import style0 from "./RouteForwarder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RouteForwarder.vue"
export default component.exports